import { ca } from '@cian/analytics';

export const trackInfoModalShow = () => {
  ca('eventSite', {
    name: 'oldevent',
    category: 'Listing',
    action: 'show_sopr',
    label: 'distribution_content_modal_open',
    page: {
      extra: {
        modal_type: 'discounts',
        source: 'filters',
      },
    },
  });
};

export const trackNextInfoSlideShow = () => {
  ca('eventSite', {
    name: 'oldevent',
    category: 'Listing',
    action: 'Scroll',
    label: 'distribution_content_modal',
    page: {
      extra: {
        modal_type: 'discounts',
      },
    },
  });
};

export const trackInfoArticleClick = (articleId: number) => {
  ca('eventSite', {
    name: 'oldevent',
    category: 'Magazine',
    action: 'click_sopr',
    label: 'Article',
    page: {
      extra: {
        modal_type: 'discounts',
        article_id: articleId,
      },
    },
  });
};
